import React, { useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import { useNavigate } from 'react-router-dom'
import { Col, Nav, Row, Spinner, Tab } from 'react-bootstrap'
import Card from '../../../components/Card'
import ViewNonLalinHeader from './view/ViewNonLalinHeader'
import ViewNonLalinDetil from './view/ViewNonLalinDetil'
import ViewNonLalinDok from './view/ViewNonLalinDok'
import ViewNonLalinKemasan from './view/ViewNonLalinKemasan'

const ViewEditNonLalin = () => {
    const [selectedTab, setSelectedTab] = useState('entitas')
    const [dataHeader, setDataHeader] = useState({})
    const [dataDetil, setDataDetil] = useState({})
    const [dataDokumen, setDataDokumen] = useState({})
    const [dataKemasan, setDataKemasan] = useState({})
    const [loading, setLoading] = useState(false)
    const [nomoraju, setNomoraju] = useState(null)

    let nonLalinService = useMemo(() => new NonlalinService(), [])

    const navigate = useNavigate()

    const handleSelectTab = async (key) => {
        setLoading(true)
        let noaju = localStorage.getItem('nomorAjuStorage')
        setSelectedTab(key)
        let response
        try {
            if (key === 'entitas') {
                if (noaju !== null) {
                    response = await nonLalinService.getNonlalinHeader(noaju)
                    setDataHeader(response.data)
                } else {
                    setDataHeader({})
                }
            } else if (key === 'detil') {
                if (noaju !== null) {
                    response = await nonLalinService.listNonlalinDtlAll(noaju)
                    setDataDetil(response.data)
                } else {
                    setDataDetil({})
                }
            } else if (key === 'dokumen') {
                if (noaju !== null) {
                    response = await nonLalinService.listNonlalinDokAll(noaju)
                    setDataDokumen(response.data)
                } else {
                    setDataDokumen({})
                }
            } else if (key === 'kemasan') {
                if (noaju !== null) {
                    response = await nonLalinService.listNonlalinKemasanAll(noaju)
                    setDataKemasan(response.data)
                } else {
                    setDataKemasan({})
                }
            }
        } catch (error) {
            setDataHeader({})
            setDataDetil({})
            setDataDokumen({})
            setDataKemasan({})
        }
        setLoading(false)
    }

    const backToDraft = () => {
        navigate('/nonlalin/draft')
    }

    useState(() => {
        let nomorAju = localStorage.getItem('nomorAjuStorage')
        const fetchData = async (noaju) => {
            setLoading(true)
            try {
                let response
                if (selectedTab === 'entitas') {
                    if (noaju !== null) {
                        response = await nonLalinService.getNonlalinHeader(noaju)
                        setDataHeader(response.data)
                    } else {
                        setDataHeader({})
                    }
                } else if (selectedTab === 'detil') {
                    if (noaju !== null) {
                        response = await nonLalinService.listNonlalinDtlAll(noaju)
                        setDataDetil(response.data)
                    } else {
                        setDataDetil({})
                    }
                } else if (selectedTab === 'dokumen') {
                    if (noaju !== null) {
                        response = await nonLalinService.listNonlalinDokAll(noaju)
                        setDataDokumen(response.data)
                    } else {
                        setDataDokumen({})
                    }
                } else if (selectedTab === 'kemasan') {
                    if (noaju !== null) {
                        response = await nonLalinService.listNonlalinKemasanAll(noaju)
                        setDataKemasan(response.data)
                    } else {
                        setDataKemasan({})
                    }
                }
            } catch (error) {
                setDataHeader({})
                setDataDetil({})
                setDataDokumen({})
                setDataKemasan({})
            }
            setLoading(false)
        }
        fetchData(nomorAju)
        setNomoraju(nomorAju)
    }, [selectedTab])

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="13">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Form Permohonan Layanan Laboratorium & Jasa Lainnya</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Tab.Container defaultActiveKey="entitas" onSelect={handleSelectTab} activeKey={selectedTab}>
                                    <Nav variant='tabs'>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'entitas'}>Entitas</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'detil'} disabled={nomoraju == null}>Detil</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'dokumen'} disabled={nomoraju == null}>Dokumen</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey={'kemasan'} disabled={nomoraju == null}>Kemasan</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'entitas'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewNonLalinHeader dataHeader={dataHeader} cancelHeader={backToDraft} saveHeader={handleSelectTab} />
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'detil'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewNonLalinDetil dataDetil={dataDetil} saveDetil={handleSelectTab} cancelDetil={handleSelectTab}/>
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'dokumen'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewNonLalinDok dataDokumen={dataDokumen} saveDokumen={handleSelectTab} cancelDokumen={handleSelectTab}/>
                                        </Tab.Pane>
                                    </Tab.Content>
                                    <Tab.Content>
                                        <Tab.Pane eventKey={'kemasan'}>
                                            {loading && <Spinner animation='border' />}
                                            <ViewNonLalinKemasan dataKemasan={dataKemasan} saveKemasan={backToDraft} cancelKemasan={handleSelectTab}/>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Tab.Container>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default ViewEditNonLalin